export const API_URL = process.env.REACT_APP_BACKEND_URL;
console.log('API : ' + API_URL);

export const UPLOAD_URL = process.env.PUBLIC_BASE;

// export const API_URL = 'http://localhost:3000/api';
// export const UPLOAD_URL = 'http://localhost:3000/';
